import React from 'react';
import { IFullWidthActionButtonProps } from "../../../interfaces/buttons/buttons"


function getClassNames(useAppThemeColors?: boolean, useTranslucentButton?: boolean) {
    let className = ""
    if(useAppThemeColors) {
        className += 'app-theme-button';
    }
    if (useTranslucentButton) {
        className += 'translucent-button';
    }

    return className;
}

const FullWidthActionButton = ({onClick, text, label, isDisabled, useAppThemeColors, useTranslucentButton}: IFullWidthActionButtonProps) => {
    return (
        <button
            className={`button-full-width-action ${getClassNames(useAppThemeColors, useTranslucentButton)}`}
            onClick={onClick}
            aria-label={label}
            disabled={isDisabled}
            type='button'
        >
            {text}
        </button>

    )
    
}

export { FullWidthActionButton }